import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaAd, FaLayerGroup, FaBullhorn, FaUsers, FaTachometerAlt, FaImage } from 'react-icons/fa';

const SponsoredAdsNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    // For dashboard, check if we're at the root path
    if (path === '/sponsored-ads$') {
      return location.pathname === '/sponsored-ads';
    }
    
    // For other tabs, check if the path exactly matches
    return location.pathname === path;
  };

  return (
    <Nav className="mb-4 border-bottom" style={{ padding: '10px 0' }}>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads"
          variant={isActive('/sponsored-ads$') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaTachometerAlt className="me-2" />
          Dashboard
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads/campaigns"
          variant={isActive('/sponsored-ads/campaigns') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaBullhorn className="me-2" />
          Campaigns
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads/ad-sets"
          variant={isActive('/sponsored-ads/ad-sets') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaLayerGroup className="me-2" />
          Ad Sets
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads/ads"
          variant={isActive('/sponsored-ads/ads') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaAd className="me-2" />
          Feed Ads
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads/banner-ads"
          variant={isActive('/sponsored-ads/banner-ads') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaImage className="me-2" />
          Banner ads
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/sponsored-ads/users"
          variant={isActive('/sponsored-ads/users') ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaUsers className="me-2" />
          Ad Users
        </Button>
      </Nav.Item>
    </Nav>
  );
};

export default SponsoredAdsNav; 